// Нэвтэрсэн хэрэглэгчийн эрх (/access/me): рольууд + модуль бүрийн түвшин (own < view < edit).
// can("payments") — харах эрхтэй юу; can("students", "own") — өөрийнхөө ч болов; can("access", "edit") — засах.
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { instance } from "utils/axios";

const AccessContext = React.createContext({ loading: true, perms: {}, roles: [], isSuper: false, can: () => false, reload: () => {} });
const RANK = { own: 1, view: 2, edit: 3 };

// Эрхийг хөтөчид кэшлэнэ (токеноор): дараагийн нээлтэд шууд зурагдаж, /access/me арын горимд шинэчилнэ.
// Зөвхөн UI-д нөлөөлнө — эрхийг сервер өөрөө шалгадаг.
const CACHE = "accessMe";
const tokenKey = () => { try { return (JSON.parse(localStorage.getItem("userInfo") || "{}").token || "").slice(-24); } catch (e) { return ""; } };
const readCache = () => { try { const c = JSON.parse(localStorage.getItem(CACHE) || "null"); return c && c.k === tokenKey() ? c.d : null; } catch (e) { return null; } };

export function AccessProvider({ children }) {
  const [data, setData] = useState(readCache);
  const load = useCallback(() => {
    instance({ method: "get", url: "/access/me", noMessage: true })
      .then((r) => { setData(r.data); try { localStorage.setItem(CACHE, JSON.stringify({ k: tokenKey(), d: r.data })); } catch (e) { /* кэшгүй ч ажиллана */ } })
      .catch(() => setData((d) => d || { perms: {}, roles: [], isSuper: false }));
  }, []);
  useEffect(() => { load(); }, [load]);
  // scope "admin" — удирдлагын хэсэгт багш/зөвлөхийн рольгүй эрхээр (adminPerms) цэс, хуудсыг харуулна (contexts/portal тохируулна)
  const [scope, setScope] = useState(null);
  const value = useMemo(() => {
    const perms = (scope === "admin" && data?.adminPerms) || data?.perms || {};
    return {
      loading: !data, perms, roles: data?.roles || [], isSuper: !!data?.isSuper, reload: load, setScope,
      adminModules: Object.keys(data?.adminPerms || {}), // удирдлагын хэсэгт хамаарах модулиуд (нэмэлт эрхийг оруулаад)
      can: (module, level = "view") => !!data && (data.isSuper || (RANK[perms[module]] || 0) >= (RANK[level] || 2)),
    };
  }, [data, load, scope]);
  return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>;
}

export const useAccess = () => useContext(AccessContext);
